import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';
import Loader from '../Loader';

const AuthorizeRoute = ({ element, path, roles }) => {
    const [ready, setReady] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [hasAccess, setHasAccess] = useState(false);

    const populateAuthenticationState = async () => {
        const isAuthenticated = await authService.isAuthenticated();
        let userHasAccess = isAuthenticated;

        if (isAuthenticated && roles && roles.length > 0) {
            const user = await authService.getUser();
            const userRoleData = user?.profile?.role || [];
            const userRoles = Array.isArray(userRoleData) ? userRoleData : [userRoleData];
            userHasAccess = roles.some(role => userRoles.includes(role));
        }

        setReady(true);
        setAuthenticated(isAuthenticated);
        setHasAccess(userHasAccess);
    };

    const authenticationChanged = async () => {
        setReady(false);
        setAuthenticated(false);
        setHasAccess(false);
        await populateAuthenticationState();
    };

    useEffect(() => {
        const subscription = authService.subscribe(() => authenticationChanged());
        populateAuthenticationState();

        return () => {
            authService.unsubscribe(subscription);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!ready) {
        return <Loader />;
    }

    const returnUrl = path ? `${window.location.origin}${path}` : window.location.origin;
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;

    if (!authenticated) {
        return <Navigate replace to={redirectUrl} />;
    }

    if (!hasAccess) {
        return <Navigate replace to={ApplicationPaths.Login} />;
    }

    return element;
};

export default AuthorizeRoute;
